export const messages = {
  attention: "Atenção",
  closeAll: "Todas as abas serão fechadas! Deseja continuar?",
  closeRight:
    "Todas as abas à direita da atual serão fechadas! Deseja continuar?",
  closeOthers:
    "Todas as abas, com exceção da atual, serão fechadas! Deseja continuar?",
  exitWarn1: "Se você sair perderá todas as informações.",
  exitWarn2: "Deseja realmente sair?",
  themeChooseTitle: "Escolha uma opção",
  themeConfirmWarn1:
    "Se você mudar o tema, perderá as informações pesquisadas.",
  themeConfirmWarn2: "Deseja realmente continuar?",
  themeNeedSelect: "Você precisa selecionar um tema para prosseguir. ⚠⚠",
  pwdTitle: "Alterar Senha",
  pwdCurrent: "Senha atual",
  pwdNew: "Nova senha",
  pwdConfirm: "Confirmar nova senha",
  pwdMismatch: "Nova senha e confirmação não conferem.",
  pwdRequired: "Preencha todos os campos.",
  pwdGenericError: "Não foi possível alterar a senha.",
  pwdSuccess: "Senha alterada com sucesso.",
  pwdCurrentIncorrect: "Senha atual incorreta.",
  pwdSameAsCurrent: "Senha já em uso.",
};
